import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { clinicaGuard } from '../../core/guards/clinica.guard';

export const clinicaRoutes: Routes = [
  {
    path: 'clinica',
    canActivate: [authGuard, clinicaGuard],
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'pacientes',
        loadComponent: () => import('./pacientes/pacientes.component').then(m => m.PacientesComponent)
      },
      {
        path: 'medicos',
        loadComponent: () => import('./medicos/medicos.component').then(m => m.MedicosComponent)
      },
      {
        path: 'agenda',
        loadComponent: () => import('./agenda/agenda.component').then(m => m.AgendaComponent)
      },
      {
        path: 'consultas',
        loadComponent: () => import('./consultas/consultas.component').then(m => m.ConsultasComponent)
      },
      {
        path: 'prontuarios',
        loadComponent: () => import('./prontuarios/prontuarios.component').then(m => m.ProntuariosComponent)
      },
      {
        path: 'prescricoes',
        loadComponent: () => import('./prescricoes/prescricoes.component').then(m => m.PrescricoesComponent)
      },
      {
        path: 'banco-sangue',
        loadComponent: () => import('./banco-sangue/banco-sangue.component').then(m => m.BancoSangueComponent)
      },
      {
        path: 'laboratorio',
        loadComponent: () => import('./laboratorio/laboratorio.component').then(m => m.LaboratorioComponent)
      },
      {
        path: 'imagiologia',
        loadComponent: () => import('./imagiologia/imagiologia.component').then(m => m.ImageologiaComponent)
      },
      {
        path: 'maternidade',
        loadComponent: () => import('./maternidade/maternidade.component').then(m => m.MaternidadeComponent)
      },
      {
        path: 'oncologia',
        loadComponent: () => import('./oncologia/oncologia.component').then(m => m.OncologiaComponent)
      },
      {
        path: 'hemodialise',
        loadComponent: () => import('./hemodialise/hemodialise.component').then(m => m.HemodialiseComponent)
      },
      {
        path: 'reabilitacao',
        loadComponent: () => import('./reabilitacao/reabilitacao.component').then(m => m.ReabilitacaoComponent)
      },
      {
        path: 'recursos-humanos',
        loadComponent: () => import('./recursos-humanos/recursos-humanos.component').then(m => m.RecursosHumanosComponent)
      },
      {
        path: 'logistica',
        loadComponent: () => import('./logistica/logistica.component').then(m => m.LogisticaComponent)
      },
      {
        path: 'financeiro',
        loadComponent: () => import('./financeiro/financeiro.component').then(m => m.FinanceiroComponent)
      },
      {
        path: 'estoque',
        loadComponent: () => import('./estoque/estoque.component').then(m => m.EstoqueClinicaComponent)
      },
      {
        path: 'atendimento',
        loadComponent: () => import('./atendimento/atendimento.component').then(m => m.AtendimentoComponent)
      },
      {
        path: 'internamento',
        loadComponent: () => import('./internamento/internamento.component').then(m => m.InternamentoComponent)
      },
      {
        path: 'bloco-operatorio',
        loadComponent: () => import('./bloco-operatorio/bloco-operatorio.component').then(m => m.BlocoOperatorioComponent)
      },
      {
        path: 'convenios',
        loadComponent: () => import('./convenios/convenios.component').then(m => m.ConveniosComponent)
      },
      {
        path: 'usuarios',
        loadComponent: () => import('./usuarios/usuarios.component').then(m => m.UsuariosComponent)
      },
      {
        path: 'especialidades',
        loadComponent: () => import('./especialidades/especialidades.component').then(m => m.EspecialidadesComponent)
      },
      {
        path: 'salas',
        loadComponent: () => import('./salas/salas.component').then(m => m.SalasComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./relatorios/relatorios.component').then(m => m.RelatoriosComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./perfil/perfil.component').then(m => m.PerfilComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.NotificacoesComponent)
      },
      {
        path: 'auth-debug',
        loadComponent: () => import('./auth-debug/auth-debug.component').then(m => m.AuthDebugComponent)
      },
      {
        path: 'farmacia-hospitalar',
        loadComponent: () => import('./farmacia-hospitalar/farmacia-hospitalar.component').then(m => m.FarmaciaHospitalarComponent)
      },
      {
        path: 'nutricao',
        loadComponent: () => import('./nutricao/nutricao.component').then(m => m.NutricaoComponent)
      },
      {
        path: 'fisioterapia',
        loadComponent: () => import('./fisioterapia/fisioterapia.component').then(m => m.FisioterapiaComponent)
      },
      {
        path: 'psicologia',
        loadComponent: () => import('./psicologia/psicologia.component').then(m => m.PsicologiaComponent)
      }
    ]
  }
];
